module.exports = __webpack_public_path__ + "210adf313f2795491576c6fd9303d32f.svg";